import * as log from 'loglevel';
import RenderUtil from './render-util';
import {cdnImg, isCdn} from '../shopify-cdn';


class LayerRenderer {

    render(layer, context, canvas){

    }

    _getOptions(layer, context, params = layer.params){

        let options = {
            visible: true,
            selectable: false,
            evented: false,
            lockUniScaling: true, // default .. no support in fabric 4..
            lockRotation: true,
            lockScalingX: true,
            lockScalingY: true,
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            lockScalingFlip: true // prevent scaling to flip y/x ( could be detected via object.flipX/Y flag - would require support on the server )
        };

        options.visible = true;

        // NEW: support rendering with visible state (pre load)
        if(layer.hasOwnProperty('_visible')){
            options.visible = layer._visible;
        }

        options.centeredRotation = true;

        // reset if auto rotated
        if(params.autoRotate){
            options.angle = 0; // reset if removed
        } else if(typeof params.angle !== 'undefined'){
            options.angle = params.angle % 360;
        }

        // only set coordinates if not auto positioning
        if(params.autoPos && !layer._interactive){ // NEW: exclude if layer was interactive moved by customer (flag is set in event object:moving)
            // important reset
            options.left = 0;
            options.top = 0;
        } else {
            if(typeof params.x !== 'undefined'){
                options.left = params.x;
            }
            if(typeof params.y !== 'undefined'){
                options.top = params.y;
            }
        }

        // scale only if not auto scaled
        if(params.autoScale && !layer._interactiveScaled) { // NEW: exclude if layer was interactive scaled by customer (flag is set in event object:scaling)
            // important reset scale
            options.scaleX = 1;
            options.scaleY = 1;
        } else {
            if(typeof params.scaleX !== 'undefined'){
                options.scaleX = params.scaleX;
            }
            if(typeof params.scaleY !== 'undefined'){
                options.scaleY = params.scaleY;
            }
        }

        // fixed dimensions - NOT for uploads with a scale box, where width/height are the box to
        // scale INTO (_applyAutoParams): mapping them onto the fabric image would crop the source
        if(!RenderUtil.hasScaleBox(layer, params)){
            if(typeof params.width !== 'undefined'){
                options.width = params.width;
            }
            if(typeof params.height !== 'undefined'){
                options.height = params.height;
            }
        }

        // check if this specific layer is currently edited
        if (RenderUtil.isEditLayer(layer, context.editorMode, context.editLayer) && !context.cropMode) {
            // exclude editor mode if this layer has a reference rect
            if(!RenderUtil.hasRefRect(layer)){
                // only allow if not automatic positioned/scaled
                options.lockMovementX = layer.params.autoPos === true;
                options.lockMovementY = layer.params.autoPos === true;

                options.lockScalingX = layer.params.autoScale === true;
                options.lockScalingY = layer.params.autoScale === true;

                let changeable = !layer.params.autoPos || !layer.params.autoScale;

                options.hasControls = changeable;
                options.selectable = changeable;
                options.evented = changeable;

                options.lockRotation = false;
            }
            /*
             NEW: refRect + manual position (autoPos=false) - keep the object selectable so the merchant can drag it to a manual
             starting x/y, while the ref box still controls the bounding area. x/y is already applied above (the autoPos=false else
             branch) and the object:modified handler writes it back to params.x/y. Move only: scaling/rotation stay governed by the
             ref box (+ autoScale, which hasRefRect requires when autoPos is off). The ref box is added BELOW the object (renderers
             call _addRefRect before canvas.add) so dragging the object sets the position and grabbing the box margins/handles still
             resizes it. Applies to inline refRects and refArea consumers alike (refArea boxes are read-only, so no selection conflict).
             */
            else if(!layer.params.autoPos){
                options.lockMovementX = false;
                options.lockMovementY = false;

                // NEW: scale box uploads (section 10) - resizing the edit object writes the scaled
                // dimensions back to params.width/height (object:modified in product-preview), so the
                // merchant places AND sizes the box by direct manipulation; other manual layers stay move-only
                let scaleBox = RenderUtil.hasScaleBox(layer, params);
                options.lockScalingX = !scaleBox;
                options.lockScalingY = !scaleBox;
                options.hasControls = scaleBox;

                options.selectable = true;
                options.evented = true;
            }
        } else if (RenderUtil.isCropLayer(layer, context.cropMode, context.cropLayer)) {

            // allow movement
            options.lockMovementX = false;
            options.lockMovementY = false;

            // IMPORTANT: temporary disable interactive flag (to prevent autoScale lockMovementX/Y)
            params.interactive = false;

            // INFO: scaling is disabled in favour of manual scaling buttons (better touch support & to prevent scaling smaller than the corp area)
            let allowScaling = false;
            options.lockScalingX = !allowScaling;
            options.lockScalingY = !allowScaling;
            options.hasControls = allowScaling;

            options.selectable = true;
            options.evented = true;
            // selection border color
            options.borderColor = 'rgb(178,204,255)'; // default
            options.borderScaleFactor = 1; // width not configurable

        } else if(layer.params.interactive && !context.cropMode){  // interactive (editable by user)
            // IMPORTANT: only if not in editorMode OR (no backend layer selected - for testing interactive)
            if(!context.editorMode || !RenderUtil.hasEditLayer(context.editorMode, context.editLayer)){
                options.lockMovementX = false;
                options.lockMovementY = false;

                // upload layer implicit resizable  && not autoScaleOverlay (to avoid scaling below overlay)
                if(layer.type === 'upload' && !params.autoScaleOverlay && typeof params.resizable == 'undefined'){ // exclude if explicitly defined
                    params.resizable = true;
                }

                // rotation - still breaks interactiveBox (rotation currently disabled in backend)
                if (params.rotatable) {
                    options.lockRotation = false;
                }

                if (params.resizable) {
                    options.lockScalingX = false;
                    options.lockScalingY = false;
                }

                options.hasControls = params.resizable || params.rotatable;

                if(options.hasControls){
                    options.transparentCorners = false; // fill corners
                    options.cornerStyle = 'circle';
                    options.cornerSize =  window.clPreviewCorner || 20; // OLD: mobile bit bigger corners fabric.isTouchSupported ? 20 : 20
                    options.cornerColor = layer.params.interactiveColor || 'rgb(178,204,255)';
                }

                options.selectable = true;
                options.evented = true;
                // selection border color
                options.borderColor = layer.params.interactiveColor || 'rgb(178,204,255)'; // default fabric
                // options.borderScaleFactor = 2; // width not configurable
            }
        }

        /* NOT RELEASED (ios no auto file picker open support from selection event):
         clickable not fully interactive (no controls) (can extend Interactive)
        if(!RenderUtil.isEditLayer(layer, context.editorMode, context.editLayer) && layer._clickable && !context.cropMode){
            options.selectable = true;
            options.evented = true;
            options.hoverCursor = 'pointer';
        } */

        // NEW: auto mask with the box ref rect (works with all types) - INFO: custom layer mask can overwrite this
        // EXCLUDE: text (fancy fonts can be cut off)
        // EXCLUDE: canvasRotate not supported with absolutePositioned ref ( could be solved with additional rotation and movement of the refRect - but simpler to just skip the clipPath)
        if(RenderUtil.hasRefRect(layer) && (layer.type !== 'text' && layer.type !== 'textbox') && isNaN(context.canvasRotate)){
            let refRect = this._getRefRect(layer, context);
            // absolute sets the box fixed instead of relative to the object
            refRect.set('absolutePositioned', true);

            // NEW: THIS avoids setting cords at 0.5/0.5: http://fabricjs.com/fabric-gotchas  (for cleaner exports)
            refRect.set('strokeWidth', 0);

            options.clipPath = refRect;
        }

        // store layer reference on the object ( is used in the events )
        options._layer = layer;

        return options;
    }

    _isEditorMode(layer, context){
        if (context.editorMode) {

            // optional  filter
            if (context.editLayer) {
                // exact match ||  // hacky child layer support  ( startsWith not supported in IE - but this is only used in editorMode )
                if(layer.name === context.editLayer || layer.name.startsWith(context.editLayer + '_')){
                    return true;
                }

                // filtered out
                return false;
            }

            return true;
        }

        return false;
    }

    _printObject(object){
        log.debug("width/height =",object.width, object.height);
        log.debug("scaled width/height =",object.getScaledWidth(), object.getScaledHeight());
        log.debug("left/top = ",object.left, object.top);
        log.debug("boundingRect = ",object.getBoundingRect());
        log.debug("boundingRectAbsolute = ",object.getBoundingRect(true));
        log.debug("boundingRectCalc = ",object.getBoundingRect(false, true));
        log.debug("boundingRectAbsoluteCalc = ",object.getBoundingRect(true, true));
    }

    _applyAutoParams(object, layer, context, params = layer.params){

        let refCoordinates = RenderUtil.getRefCoordinates(layer, context);
        let refDimensions = RenderUtil.getRefDimensions(layer, context);

        // NEW: upload scale box (docs/layer-area.md section 10) - autoScale fits the image into
        // params.width/height instead of the full ref box. The position comes from params.x/y
        // (autoPos=false, applied in _getOptions) and the ref geometry (inline refRect or materialized
        // refArea) keeps governing movement bounds, clipPath and crop. width/height are never written
        // back at runtime (object:modified persists x/y/scaleX/scaleY only), so every new upload
        // re-fits into the configured box while the position keeps the customer intent
        if(RenderUtil.hasScaleBox(layer, params)){
            refDimensions = {
                width: params.width || refDimensions.width,
                height: params.height || refDimensions.height
            };
        }

        // scaled dimensions
        let dimensions = RenderUtil.getDimensions(object);

        // unscaled original dimensions
        let originalDimensions = {
            width: object.width,
            height: object.height
        };

        /* test only
       let level = log.getLevel();

       if (level <= log.levels.TRACE) {
           log.debug('====> layer Auto params [BEFORE]: ');
           this._printObject(object);
       } */

        /*
         INFO: logic is based on AutoModificationPlugin from template-js
               BUT instead of storing calculated values in the .params we directly apply it to the object
         */
        if (params.autoScale && !layer._interactiveScaled) { // NEW: exclude if layer was interactive scaled by customer (flag is set in event object:scaling)

            // temp variable to allow temporary changes
            let autoScaleRatio = params.autoScaleRatio;
            let autoScaleMax = params.autoScaleMax;
            // NEW: scale the smaller side to completely overlay the reference dimensions (overlay can extend the box)
            let autoScaleOverlay = params.autoScaleOverlay || false;

            // text always scales both sides ( because we change the font size )
            if (layer.type === 'text') {
                autoScaleRatio = true;
            }

            let scale = 1;
            // calculate scale of the unscaled object to fix maximally into the dimensions
            let scaleX = refDimensions.width / originalDimensions.width;
            let scaleY = refDimensions.height / originalDimensions.height;

            // scale up     OR  image is already bigger than ref dimensions
            if(autoScaleMax || (dimensions.height > refDimensions.height || dimensions.width > refDimensions.width)){
                if(autoScaleRatio){
                    // overlay use the bigger scale (scales the smaller size)
                    if(autoScaleOverlay){
                        scale = Math.max(scaleX, scaleY);

                        // interactive - only allow movement on the scale that overflows the area
                        // INFO: this still allows moving outside of the box
                        if(params.interactive){
                            if(scaleX > scaleY){
                                object.lockMovementX = true;
                            } else {
                                object.lockMovementY = true;
                            }
                        }
                    }
                    // default use the smaller scale to avoid overflow
                    else {
                        scale = Math.min(scaleX, scaleY);
                    }

                    object.scaleX = scale;
                    object.scaleY = scale;
                } else {
                    // scale both sides individually
                    object.scaleY = scaleY;
                    object.scaleX = scaleX;
                }

                // IMPORTANT: to update coords for reference in getScaledHeight/Width  ( same as if we would call .scale()  on the object )
                object.setCoords();

                // re calc dimensions to reflect changed scale
                dimensions = RenderUtil.getDimensions(object);
            }


            // custom text scaling
            if (scale !== 1 && layer.type === 'text') {

                /*  DISABLED: seems to fuck up the selection element leaving the wrong position
                  setCoords did not fix it - we currently can just leave the calculated scale

                // we use the calculated scale to change the fontSize
                object.fontSize = Math.round(object.fontSize * scale); // always round to integer to avoid floating differences

                // reset text to scale 1 ( important to leave the calculated dimensions for the following center operations )
                //object.scaleX = 1;
                //object.scaleY = 1;

                // IMPORTANT: to update coords for reference in getScaledHeight/Width  ( same as if we would call .scale()  on the object )
                object.setCoords(); */

                // IMPORTANT: fontSize update does not update bounding rect (returns wrong width/height with scale = 1)
                // we have to keep the previous calculated dimensions for the following center operations
                // dimensions = this._getDimensions(object);
            }

        }

        /*
         NEW: editor-only seed for refRect manual mode - when the edit layer has no manual x/y yet (the admin stores 0,0 as the
         unset default while autoPos is on, so both coords falsy means "not placed"), reuse the auto positioning below so toggling
         autoPos off keeps it in the box instead of jumping to 0,0. Display only: the first drag writes a non-zero params.x/y
         (object:modified) which then takes over.
         */
        let seedManualPos = context.editorMode && RenderUtil.hasRefRect(layer) && !params.x && !params.y;

        // INFO: we only apply auto center if automatic positioning is enabled
        if((params.autoPos || seedManualPos) && !layer._interactive){ // NEW: exclude if layer was interactive moved by customer (flag is set in event object:moving)

            // NEW: map angle to object (currently only used with ref rect on text layers)
            if(refCoordinates.angle !== 0){
                object.angle = refCoordinates.angle;
            } else if(object.angle !== 0){
                object.angle = 0; // reset angle (editor mode)
            }

            if(params.autoCenter){ // INFO: not used anymore - autoCenter is ALWAYS a combination of autoCenterH and autoCenterV
                RenderUtil.center(object, dimensions, refCoordinates, refDimensions);
            } else {

                if(params.autoCenterH){
                    RenderUtil.centerHorizontal(object, dimensions, refCoordinates, refDimensions);
                } else {
                    // NEW: set fixed ref coordinates if autoPos
                    object.left = refCoordinates.x;

                    // NEW: textAlign support for single text (textBox text align already works because its sized to the full width)
                    if(layer.type === 'text' && !params.textBox){
                        if(params.textAlign === 'center'){
                            RenderUtil.centerHorizontal(object, dimensions, refCoordinates, refDimensions);
                        } else if(params.textAlign === 'right'){
                            let x = ( refCoordinates.x + refDimensions.width ) - dimensions.width;
                            object.left = parseFloat(x.toFixed(2));
                        }
                        // textAlign == left => already applied by object.left = refCoordinates.x;
                    }
                }

                if(params.autoCenterV){
                    RenderUtil.centerVertical(object, dimensions, refCoordinates, refDimensions);
                } else {
                    // NEW: set fixed ref coordinates if autoPos
                    object.top = refCoordinates.y;
                }

                // NEW: angle auto center support FULL re-position based on refRect object and fabric util functions
                if(object.angle !== 0 && (params.autoCenterH || params.autoCenterV)){

                    // create manual ref rect to get custom point by origin
                    let refRect = new fabric.Rect({
                        left: refCoordinates.x,
                        top: refCoordinates.y,
                        width: refDimensions.width,
                        height: refDimensions.height,
                        angle: object.angle,
                    });

                    // origin used to positioning that respects rotation
                    let originX = params.autoCenterH ? 'center' : 'left';
                    let originY = params.autoCenterV ? 'center' : 'top';

                    // map text align as well
                    if(layer.type === 'text' && !params.textBox){
                        if(params.textAlign === 'center'){
                            originX = 'center';
                        } else if(params.textAlign === 'right'){
                            originX = 'right';
                        }
                    }

                    // get point on ref rect
                    let point = refRect.getPointByOrigin(originX, originY);

                    // position object
                    object.setPositionByOrigin(point,originX,originY);
                }
            }
        }

        /* test only
        if (level <= log.levels.TRACE) {
           log.debug('====> layer Auto params [AFTER]: ');
           this._printObject(object);
        }*/

        // NEW: refArea placement projection - AFTER autoScale/autoPos so the clamp and the stranded
        // check measure the final displayed scale/position (not the raw pre-autoScale object)
        this._validateArea(object, layer, context, params);
   }

   /*
     NEW: refArea placement projection (docs/layer-area.md section 5)
     a manual placement (params.x/y/scaleX/scaleY + _interactive flags) is the customer's intent and is NEVER
     rewritten by geometry changes - it is projected into the resolved area at render time:
      - interactiveBox layers: scale down oversized objects to fit, then re-apply the same containment as the
        object:moving handler (clamp into the area). Runs on EVERY render (display only) so area switches stay
        fully reversible - the area the customer last interacted with shows the exact placement, others its projection
      - free layers: only when the resolved geometry changed (flag set in product-preview) - placements that no
        longer intersect the area are discarded so autoPos/autoScale re-initialize
     runs at the END of _applyAutoParams - after autoScale/autoPos established the displayed scale/position
   */
   _validateArea(object, layer, context, params = layer.params){

       // set in product-preview when the materialized area geometry changed (area switch, merchant edit)
       let geometryChanged = layer._areaCheck;
       delete layer._areaCheck;

       // nothing manual applied - autoPos/autoScale initialize as usual
       if(!layer._interactive && !layer._interactiveScaled){
           return;
       }

       // requires a ref box to project into (refArea geometry is materialized into the ref* params)
       if(!RenderUtil.hasRefRect(layer)){
           return;
       }

       // axis aligned area bounds - rotated areas use the rotated bounding box (same as the object:moving handler)
       let area = RenderUtil.getRefBounds(layer, context);

       let boundingRect = object.getBoundingRect(true, true);

       // overlay layers must COVER the box, not fit inside it - crop uploads are implicit overlays
       // (autoScaleOverlay is only injected while crop mode is active), so after a crop save
       // params.autoScaleOverlay is falsy here while the coverage invariant still holds
       let overlay = RenderUtil.isOverlay(layer, params);

       // interactiveBox layers re-contain into their box on EVERY render (display only) - applies to
       // refArea consumers (projects the placement into the resolved area) AND inline refRect boxes:
       // after autoScale rescales a moved object on a text/content change, autoPos stays disabled
       // (_interactive set on drag) so the object would keep its old dragged anchor and overflow the
       // box. Inline refRect boxes only got clamped during the drag (object:moving) before this.
       if(params.interactiveBox){

           // carried/stale placements can be bigger than the resolved box - scale down to fit (ratio kept)
           // EXCLUDE overlay layers (they must cover the box, not fit inside it)
           if(!overlay && (boundingRect.width > area.width || boundingRect.height > area.height)){
               let fitScale = Math.min(area.width / boundingRect.width, area.height / boundingRect.height);

               // IMPORTANT: display only - params keep the customer intent (re-projected on every render)
               object.scaleX = object.scaleX * fitScale;
               object.scaleY = object.scaleY * fitScale;
               object.setCoords();

               boundingRect = object.getBoundingRect(true, true);
           }

           // same containment as the object:moving handler (shared implementation incl. the
           // _interactiveScaled overlay demotion) - display only, params keep the customer intent
           RenderUtil.containObject(object, layer, boundingRect, area, RenderUtil.getRefDimensions(layer, context), overlay);

       } else if(geometryChanged && RenderUtil.usesRefArea(layer)){
           // free layers: keep placements that still intersect the area - only fully stranded ones reset
           let valid = boundingRect.left < area.left + area.width &&
               boundingRect.left + boundingRect.width > area.left &&
               boundingRect.top < area.top + area.height &&
               boundingRect.top + boundingRect.height > area.top;

           // overlay layers must COVER the resolved area (the invariant the crop zoom guard and the
           // move containment enforce during interaction) - a placement cropped/scaled for another
           // area that no longer covers this one would leave gaps and must re-initialize
           if(valid && overlay){
               valid = RenderUtil.coversBounds(boundingRect, area);
           }

           if(!valid){
               log.debug('refArea placement invalid for area - reset to auto position: ', layer.name);

               delete layer._interactive;
               delete layer._interactiveScaled;

               // re-initialize via autoPos/autoScale in this render (the flags are deleted, so the
               // projection guard exits immediately on the recursive pass - no loop)
               this._applyAutoParams(object, layer, context, params);
           }
       }
   }

   _addRefRect(object, layer, context, canvas){
       // editorMode custom reference box  && NOT cropMode
       if(RenderUtil.isEditLayer(layer, context.editorMode, context.editLayer) && !context.cropMode){

           if(RenderUtil.hasRefRect(layer)){
               let refRect = this._getRefRect(layer, context);
               canvas.add(refRect);

               // INFO: fabric 4 removed Object.lockUniScaling http://fabricjs.com/v4-breaking-changes
               // solution from github only show/hides the corner controls ( which makes the UX worse ): https://github.com/fabricjs/fabric.js/pull/6575#issuecomment-706718921
               // we currently just allow scaling not in ratio when in editorMode for all objects
               canvas.uniformScaling = false;
           } else {
               // rest to uniformScaling
               canvas.uniformScaling = true;
               // this._canvas.uniscaleKey = 'shiftKey';  default lock scaleing via shift  ( set to null to disable )
           }
       }
   }

   _getRefRect(layer, context, fields = LayerRenderer.REF_FIELDS){

       // use cached object ref
       let refRect = layer._objectRef || new fabric.Rect();

       // NEW: support ref rect based rotation (is mapped to object in autoPos logic)
       // UPDATE: support rotation for all layers EXCEPT upload + live crop (not supported)
       let allowRotation = !(layer.type === 'upload' && layer.params.crop);
       // hide rotation control if not allowed
       if(!allowRotation){
           refRect.setControlsVisibility({ mtr: false });
       }

       let refOptions = {
           visible: true,
           lockUniScaling: false, // no support in fabric 4..
           lockRotation: !allowRotation,
           lockMovementX: false,
           lockMovementY: false,
           lockScalingX: false,
           lockScalingY: false,
           hasControls: true,
           lockScalingFlip: true, // prevent scaling to flip y/x,
           selectable: true,
           evented: true
       };

       // NEW: refArea consumers show the resolved area geometry read-only - the geometry is edited on the area layer itself
       if(RenderUtil.usesRefArea(layer)){
           refOptions.selectable = false;
           refOptions.evented = false;
           refOptions.hasControls = false;
           refOptions.lockMovementX = true;
           refOptions.lockMovementY = true;
           refOptions.lockScalingX = true;
           refOptions.lockScalingY = true;
           refOptions.lockRotation = true;
       }

       // default position or configured (refArea geometry is already materialized into the ref* params)
       refOptions.left = typeof layer.params[fields.x] !== 'undefined' ? layer.params[fields.x] : 50; // IMPORTANT: allow 0 in x/y
       refOptions.top = typeof layer.params[fields.y] !== 'undefined' ? layer.params[fields.y] : 50;
       refOptions.width = layer.params[fields.width] || context.config.width - 100;
       refOptions.height = layer.params[fields.height] || context.config.height - 100;
       // IMPORTANT: always reset scale ( width/height is updated based on scale )
       refOptions.scaleX = 1;
       refOptions.scaleY = 1;
       // NEW: modify angle of ref box
       refOptions.angle = allowRotation && typeof layer.params[fields.angle] !== 'undefined' ? layer.params[fields.angle] : 0;

       refOptions.fill = '#139cf6'; // shopify color: 008060
       refOptions.opacity = 0.5;

       // store for updates via events ( handled in product-preview.js object:modified - area layers
       // write back to plain x/y/width/height/angle, inline refRects to the ref* params )
       refOptions._layerRef = layer;

       refRect.setOptions(refOptions);

       // cache reference on layer
       layer._objectRef = refRect;

       return refRect;
   }

   _getImageUrl(url, layer, context){
       // flag if cdn size parameter should be added: https://www.shopify.com/partners/blog/img-url-filter
       // applied on all images as we don't know the size without loading the image first
       // scales down larger images - smaller images are returned in their max original size
       if(context.cdnSize && isCdn(url)){

          let refDimensions = RenderUtil.getRefDimensions(layer, context);

          let bigger = Math.max(refDimensions.width, refDimensions.height);
          let xBigger = refDimensions.width > refDimensions.height;

          //INFO: preview in most cases is already downscaled to the actually preview size in the browser
          // from the original preview dimensions so it does not make sense to scale the image up
          //bigger = bigger * 1.5;

          // round to next 200
          bigger = Math.ceil(bigger / 200) * 200;

          // max 3000 pixels (everything over will make the preview slow)
          let size = Math.min(3000, bigger);

          return cdnImg(url, xBigger ? size + 'x' : 'x' + size);
       }

       return url;
   }

}

// geometry field names of the editable ref box - inline refRects store ref* params,
// area layers ARE the geometry and store plain x/y/width/height/angle (area-renderer)
LayerRenderer.REF_FIELDS = { x: 'refX', y: 'refY', width: 'refWidth', height: 'refHeight', angle: 'refAngle' };

export default LayerRenderer;